export default __webpack_public_path__ + "static/media/petitions.f31ac612.png";